// 基准大小
// 设置 rem 函数
function setRem(doc) {
	var docEle = doc.documentElement
	var width = docEle.clientWidth
	width && (docEle.setAttribute('style','font-size:'+ 20 * (width / 375) + "px !important"))
}
// 初始化
setRem(document)
// 改变窗口大小时重新设置 rem
window.onresize = function () {
    setRem(document)
}
//rem = 750设计图宽度/32